// MisGrabaciones — Página dedicada de grabaciones para docente y estudiante.
// Lista TODAS las grabaciones del usuario (sin filtrar por clase).
import { useAuth } from "@/contexts/AuthContext";
import RecordingsList from "@/components/RecordingsList";

export default function MisGrabaciones() {
  const { user } = useAuth();
  const isTeacher = user?.role === "docente";
  return (
    <div className="space-y-4" data-testid="mis-grabaciones-page">
      <div>
        <p className="text-xs tracking-[0.18em] uppercase font-bold text-[#A43790]">Sesiones</p>
        <h1 className="font-display text-3xl md:text-4xl font-extrabold text-[#1F2547]">
          {isTeacher ? "Mis grabaciones" : "Clases grabadas"}
        </h1>
        <p className="text-sm text-[#6E7591] mt-1">
          {isTeacher
            ? "Las grabaciones que has realizado de tus clases en vivo, guardadas de forma segura."
            : (user?.role === "admin" || user?.role === "franquiciado")
              ? "Todas las grabaciones de las clases en vivo, de la más reciente a la más antigua."
              : "Las grabaciones de las clases en vivo en las que has participado."}
        </p>
      </div>
      <RecordingsList canDelete={isTeacher} />
    </div>
  );
}
